import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        // A-05: Respetar el consentimiento de cookies analíticas (RGPD / LSSI Art. 22.2)
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (cookieConsent !== 'all') return;

        const token = localStorage.getItem('token');
        if (!token) return; // Sólo trackeamos a usuarios logueados de momento
        
        const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');
        
        await fetch(`${API_URL}/analytics/pageview`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ path: location.pathname })
        });
      } catch (e) {
        // Silencioso para no molestar la UX
        console.warn('No se pudo registrar pageview', e);
      }
    };

    trackPageView();
  }, [location]);

  return null;
};

export default PageViewTracker;
